import { appsCsr } from './app.csr';

appsCsr();

if (process.env.NODE_ENV === 'development') {
  module.hot?.accept();
}
